export default __webpack_public_path__ + "static/media/logo-rmi-lockup.dd4736be.svg";